// https://connect.conax.com/html5/playerdemo.html
const serializeConaxCustomDataHeader = (token, id) =>
JSON.stringify({
  Version: "1.0.0",
  CxAuthenticationDataToken: token,
  CxClientInfo: {
    DeviceType: "Browser",
    DrmClientType: "Widevine-HTML5",
    DrmClientVersion: "1.0.0",
    CxDeviceId: id
  }
});
export default serializeConaxCustomDataHeader;


// WEBPACK FOOTER //
// ./src/misc/conax.js